import { RequestStatusForType, RequestStatusState } from '../state/requestStatusState';
import { AppAction } from '../actions/appAction';
import produce from 'immer';

const unloaded: RequestStatusState = {
	requestsByType: new Map()
};

export default function requestStatusReducer(state: RequestStatusState | undefined = unloaded, action: AppAction): RequestStatusState {
	switch (action.type) {
		case 'request-status/started':
			return produce(state, draft => {
				const statusForType: RequestStatusForType = draft.requestsByType.get(action.requestType) ?? {
					requestsById: new Map()
				};
				
				statusForType.requestsById.set(action.requestId, 'pending');
				draft.requestsByType.set(action.requestType, statusForType);
			});
		case 'request-status/completed':
		case 'request-status/failed':
			return produce(state, draft => {
				const statusForType: RequestStatusForType = draft.requestsByType.get(action.requestType) ?? {
					requestsById: new Map()
				};

				statusForType.requestsById.delete(action.requestId);
				draft.requestsByType.set(action.requestType, statusForType);
			});
		default:
			return state;
	}
}